export const EULA_AR = {
  title: "اتفاقية ترخيص المستخدم النهائي",
  version: "2.0",
  updated: "2026-06-12",
  intro:
    "هذه الاتفاقية («الترخيص») تحكم استخدامك لتطبيق HELCOO على أجهزة iOS و iPadOS و Android. الترخيص مُبرم بينك وبين HELCOO («المرخِّص») فقط، وليس مع Apple Inc. أو Google LLC. جهة الاتصال: support@helcoo.uk.",
  sections: [
    {
      h: "1. نطاق الترخيص",
      p: [
        "يمنحك المرخِّص ترخيصاً شخصياً غير قابل للنقل وغير حصري وقابلاً للإلغاء لاستخدام التطبيق على أي جهاز تملكه أو تتحكم فيه، وبما تسمح به قواعد الاستخدام في شروط خدمة المتجر المعني.",
        "الترخيص مشروط باشتراك سارٍ لشركتك في الخدمة، ويُستخدم التطبيق لأغراض العمل حصراً.",
        "يُمنع توزيع التطبيق أو تأجيره أو بيعه أو منح ترخيص من الباطن، أو تعديله أو هندسته العكسية أو استخراج كوده المصدري، إلا في الحدود التي يسمح بها القانون صراحة.",
      ],
    },
    {
      h: "2. الصيانة والدعم",
      p: [
        "المرخِّص وحده مسؤول عن تقديم أي خدمات صيانة أو دعم تتعلق بالتطبيق. لا تتحمّل Apple ولا Google أي التزام بتقديم أي صيانة أو دعم.",
        "قناة الدعم الرسمية: support@helcoo.uk، وزمن الاستجابة المستهدف يومان عمل.",
      ],
    },
    {
      h: "3. الضمان",
      p: [
        "المرخِّص وحده مسؤول عن أي ضمانات، صريحة أو ضمنية، لم يُخلِ مسؤوليته منها بشكل صحيح.",
        "في حال عدم مطابقة التطبيق لأي ضمان مطبَّق، يمكنك إشعار Apple وستردّ لك Apple ثمن الشراء إن وُجد (التطبيق مجاني التحميل). وبأقصى ما يسمح به القانون، لا تتحمل Apple أي التزام آخر بخصوص الضمانات، وتظل أي مطالبات أو خسائر أو التزامات أو أضرار أخرى من مسؤولية المرخِّص.",
      ],
    },
    {
      h: "4. المطالبات المتعلقة بالمنتج",
      p: [
        "المرخِّص — لا Apple ولا Google — هو المسؤول عن معالجة أي مطالبات منك أو من أي طرف ثالث تتعلق بالتطبيق أو بحيازتك أو استخدامك له، بما فيها: مطالبات المسؤولية عن المنتج، وأي مطالبة بعدم مطابقة التطبيق لمتطلب قانوني أو تنظيمي، والمطالبات الناشئة عن قوانين حماية المستهلك أو الخصوصية أو ما شابهها، بما في ذلك ما يتعلق باستخدام التطبيق لأطر عمل التحقق البيومتري.",
      ],
    },
    {
      h: "5. حقوق الملكية الفكرية",
      p: [
        "في حال وجود أي مطالبة من طرف ثالث بأن التطبيق أو استخدامك له ينتهك حقوق ملكية فكرية لذلك الطرف، فإن المرخِّص وحده هو المسؤول عن التحقيق في المطالبة والدفاع عنها وتسويتها وتسديدها.",
      ],
    },
    {
      h: "6. الالتزام بالقوانين",
      p: [
        "تقرّ بالتزامك بكل القوانين المعمول بها، بما فيها قوانين العمل وحماية البيانات والبيانات البيومترية في بلدك.",
        "تقرّ بأنك غير موجود في بلد يخضع لحظر من حكومة الولايات المتحدة أو مُصنَّف كدولة «داعمة للإرهاب»، وأنك غير مُدرج في أي قائمة أطراف محظورة أو مقيّدة أمريكية.",
      ],
    },
    {
      h: "7. أطراف ثالثة مستفيدة",
      p: [
        "تُعدّ Apple Inc. وشركاتها التابعة أطرافاً ثالثة مستفيدة من هذه الاتفاقية، ولها حق الاعتماد عليها وإنفاذها ضدك بصفتك المستخدم النهائي.",
        "قد يحتوي التطبيق على مكوّنات لأطراف ثالثة، وتوافق على الالتزام بشروطها المعمول بها.",
      ],
    },
    {
      h: "8. مستخدمو الحكومة الأمريكية والإنهاء",
      p: [
        "يُقدَّم التطبيق كـ«برنامج تجاري» و«وثائق برنامج حاسوبي تجاري» وفق FAR 12.212 و DFARS 227.7202، وتُمنح الحقوق فقط بموجب هذه الاتفاقية.",
        "ينتهي هذا الترخيص تلقائياً عند مخالفتك لأي من شروطه أو عند انتهاء اشتراك شركتك، وعليك حينها حذف التطبيق من أجهزتك.",
        "يخضع هذا الترخيص لقوانين المملكة المتحدة، مع مراعاة أي حقوق مستهلك إلزامية في بلد إقامتك.",
      ],
    },
  ],
};
